import { combineEpics } from 'redux-observable';
import { sharedContactsEpic } from './contacts';
import { sharedHighlightsEpic } from './highlights';
import { sharedMomentsEpic } from './moments';
import { sharedNotesEpic } from './notes';
import { sharedSourcesEpic } from './sources';
import { sharedGroupsEpic } from './groups';
import { ReduxAction } from '@repo/utils/types';
import AppState from '../../reducers/app-state';

export const sharedDataEpics = combineEpics<ReduxAction, any, AppState>(
  sharedContactsEpic,
  sharedGroupsEpic,
  sharedHighlightsEpic,
  sharedMomentsEpic,
  sharedNotesEpic,
  sharedSourcesEpic,
);
